import { Stack, styled, Typography } from '@mui/material';

export const Container = styled(Stack)``;

export const HeaderTitle = styled(Typography)`
  font-weight: 400;
`;
